export default __webpack_public_path__ + "static/Montserrat-Regular-b0463f53f41af9e523ee7952b74db9c6.woff2";